<template>

    <article class="cruise-card">

        <img :src="imgUrl" :alt="cruise.imgAlt">
        <span
                class="patch-label full"
                v-if="selectedDate && showFull && breakpointDownSm">
                        complet</span>
        <span
                class="patch-label last"
                v-if="selectedDate && showLast && breakpointDownSm">
                        Dernières places</span>
        <div>
            <div class="details">
                <div>
                    <div class="like" @click="ctaFavorite()" :class="{ active: isFavorite }"
                         v-if="isMobile || okWishListLg"></div>
                    <p v-if="isMobile || okWishListLg" class="confort"><img
                            v-for="n in cruise.confort"
                            :src="fullStar"
                            alt=""><img
                            v-for="n in unConfort"
                            :src="emptyStar"
                            alt=""></p>
                    <a :href=cruise.URL><h3 class="titre" v-html=formatName(cruise.nom)></h3></a>

                    <div v-if="selectedDate">
                        <custom-select
                                v-if="cruise.dates.length > 1"
                                v-model=selectedDateIndex
                                valueField="index"
                                labelField="label"
                                :options="cruise.dates"
                        >
                        </custom-select>
                        <span v-else v-html=selectedDate.label></span>


                    </div>

                    <p v-html=extrait v-if="!isMobile && !okWishListLg"></p>
                </div>

                <div v-if="selectedDate">
                    <div class="wrap-price">
                        À partir de
                        <span v-html="selectedDate.dateMinPrice">

                        </span>
                    </div>


                    <span class="patch-label full"
                          v-if="showFull && !breakpointDownSm">complet</span>
                    <span class="patch-label last"
                          v-if="showLast && !breakpointDownSm">Dernières places</span>

                    <a :href=cruise.URL class="btn chevron outline" v-if="isMobile || okWishListLg">Découvrir</a>

                </div>
                <div v-else>
                    <span>
                        <a :href=cruise.URL class="btn chevron outline" v-if="isMobile || okWishListLg">Découvrir</a>
                    </span>
                </div>


            </div>
            <div class="cta" v-if="!isMobile && !okWishListLg">
                <div class="like" @click="ctaFavorite()" :class="{ active: isFavorite }"></div>
                <div class="confort">
                    <p>Confort</p>
                    <img
                            v-for="n in cruise.confort"
                            :src="fullStar"
                            alt=""><img
                        v-for="n in unConfort"
                        :src="emptyStar"
                        alt="">

                </div>
                <div class="navire" v-if="!cruise.is_circuit">
                    <p>Navire</p>
                    <p>{{cruise.bateau}}</p>
                </div>
                <div v-else></div>
                <a :href=cruise.URL class="btn chevron outline">Découvrir</a>
            </div>

        </div>
    </article>

</template>

<script>
    import $ from 'jquery';
    import {DateTime} from 'luxon';
    import addToWishlist from '../../mixins/addToWishList';
    import {truncate} from 'lodash';

    export default {
        mixins: [addToWishlist],
        props: {
            cruise: {
                type: Object,
                required: true,
            },

        },
        data() {
            return {
                selectedDate: null,
                isFavorite: false,
                selectedDateIndex:0
            };
        },
        filters: {},
        computed: {
            showFull() {
                return this.selectedDate.dateSeatsLeft === 0;
            },
            showLast() {
                return this.selectedDate.dateSeatsLeft <= 2 && this.selectedDate.dateSeatsLeft > 0;
            },
            imgUrl() {
                return (this.isMobile || this.okWishListLg) ? this.cruise.imgUrlWide : this.cruise.imgUrlSquare;
            },
            fullStar() {
                return window.GrandsEspaces.card_stars_full;
            },
            emptyStar() {
                return window.GrandsEspaces.card_stars_empty;
            },
            extrait() {
                let str = truncate(this.cruise.description, {
                    'length': 115,
                    'separator': /,? +/,
                    'omission': ' ...'
                });
                return str.replace(/<[^>]*>/g, '');
            },
            unConfort() {
                return 5 - this.cruise.confort;
            },
            isMobile() {
                return this.$root.isMobile;
            },
            breakpointDownSm() {
                return this.$root.breakpointDownSm;
            },
            okWishListLg() {
                return ($('body').hasClass('woocommerce-account') && this.$root.breakpointOnlyLg);
            }
        },
        methods: {
            formatDateInterval(start, end) {
                let startString = start.hasSame(end, 'year') ?
                    start.toLocaleString({month: 'long', day: 'numeric'}) :
                    start.toLocaleString(DateTime.DATE_FULL);
                let endString = end.toLocaleString(DateTime.DATE_FULL);

                return `${startString}&nbsp;&nbsp;>&nbsp;&nbsp;${endString}`;
            },
            formatName(value) {
                return value.replace("<br>", "");
            },

        },
        watch: {
            selectedDateIndex: function (val) {
                let index = Number(val)
                this.selectedDateIndex = index
                this.selectedDate = this.cruise.dates[index]
            }
        },
        beforeMount() {
            if (this.cruise.dates.length !== 0) {

                this.selectedDate = this.cruise.dates[0];

                this.cruise.dates.map((date, i) => {
                    date.label = this.formatDateInterval(DateTime.fromISO(date.start_date), DateTime.fromISO(date.end_date));
                    date.index = i;
                    return date;
                });

            }

            this.isFavorite = this.cruise.isFavorite;

        },
        mounted() {
        },
        destroyed() {

        },
    };
</script>


// WEBPACK FOOTER //
// assets/js/components/cruise-product/CruiseCard.vue